module.exports = __webpack_public_path__ + "img/chestnut_white_ba_detail_rsh.19620a4f.jpg";